import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from 'components/Auth/AuthContext';

const ProtectedRoute = ({ component: Component, roles, ...rest }) => {
    function getToken() {
      return localStorage.getItem('authToken');
    }
    const token = getToken();
    const userRole = localStorage.getItem('role');
  
    return (
      <Route
        {...rest}
        render={props =>
          token && (!roles || roles.includes(userRole)) ? (
            <Component {...props} />
          ) : (
            <Redirect to="/auth/login" />
          )
        }
      />
    );
  };

export default ProtectedRoute;
